/* Nucery Collection Showcase: AJAX facet updates (Section Rendering API), price sync, drawer. */
(function () {
  'use strict';

  if (window.__nuceryCollectionShowcase) return;
  window.__nuceryCollectionShowcase = 1;

  /** Availability uses the same param for in/out stock; only one value may be active (see merge + sync). */
  var NCS_AVAILABILITY_PARAM = 'filter.v.availability';

  function closest(el, sel) {
    return el && el.closest ? el.closest(sel) : null;
  }

  function openDrawer(drawer, trigger) {
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
    document.documentElement.classList.add('ncs-drawer-open');
  }

  function closeDrawer(drawer, trigger) {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
    document.documentElement.classList.remove('ncs-drawer-open');
  }

  function formatMoney(cents, moneyFormat) {
    if (moneyFormat == null || moneyFormat === '') {
      return String(cents);
    }
    var fmt =
      typeof moneyFormat === 'string' && moneyFormat.charAt(0) === '"' && moneyFormat.slice(-1) === '"'
        ? (function () {
            try {
              return JSON.parse(moneyFormat);
            } catch (e) {
              return moneyFormat.slice(1, -1);
            }
          })()
        : moneyFormat;
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    var match = String(fmt).match(placeholder);
    if (!match) {
      return String(cents);
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands || ',';
      decimal = decimal || '.';
      if (isNaN(number) || number == null) {
        return '0';
      }
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? decimal + parts[1] : '';
      return dollarsAmount + centsAmount;
    }

    var value = '';
    switch (match[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'", '.');
        break;
      case 'amount_no_decimals_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 0, "'", '.');
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ', ',');
        break;
      case 'amount_with_period_and_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', '.');
        break;
      default:
        value = formatWithDelimiters(cents, 2);
    }
    return String(fmt).replace(placeholder, value);
  }

  /**
   * Format cents for storefront display. Prefer formatStr from Liquid (shop/market formatting);
   * do not override with theme.settings.moneyFormat — that breaks Markets / multi-currency vs filters.
   */
  function formatDisplayMoney(cents, formatStr) {
    var fmt = formatStr != null && String(formatStr).trim() !== '' ? formatStr : null;
    if (!fmt && window.theme && window.theme.settings && window.theme.settings.moneyFormat) {
      fmt = window.theme.settings.moneyFormat;
    }
    if (!fmt) fmt = '${{amount}}';

    var str = '';
    if (window.theme && window.theme.Currency && typeof window.theme.Currency.formatMoney === 'function') {
      try {
        str = window.theme.Currency.formatMoney(cents, fmt);
      } catch (e) {
        str = '';
      }
    }
    if (!str && typeof window.Shopify !== 'undefined' && typeof window.Shopify.formatMoney === 'function') {
      try {
        str = window.Shopify.formatMoney(cents, fmt);
      } catch (e2) {
        str = '';
      }
    }
    if (!str) {
      str = formatMoney(cents, fmt);
    }
    if (/<[^>]+>/.test(str)) {
      var d = document.createElement('div');
      d.innerHTML = str;
      return (d.textContent || d.innerText || String(cents)).trim();
    }
    return str;
  }

  function normalizeIsoCurrency(s) {
    if (s == null || s === '') return null;
    var u = String(s).trim().toUpperCase();
    return /^[A-Z]{3}$/.test(u) ? u : null;
  }

  /** Mirrors Shopify Markets / Currency JS (see nucery-header-search.js formatMoney fallback). */
  function getShopifyActiveCurrencyIso() {
    var c = window.Shopify && window.Shopify.currency && window.Shopify.currency.active;
    if (!c) return null;
    if (typeof c === 'string') return normalizeIsoCurrency(c);
    if (typeof c === 'object' && c.iso_code != null) return normalizeIsoCurrency(String(c.iso_code));
    return null;
  }

  function formatMoneyIntlMinorUnits(cents, currencyIso) {
    if (!currencyIso) return null;
    var minor = Number(cents);
    if (!isFinite(minor)) return null;
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: currencyIso }).format(minor / 100);
    } catch (e) {
      return null;
    }
  }

  /**
   * Facet range values use the customer's currency; shop.money_format in data attrs is shop-default.
   * When presentment differs from shop, Intl matches product card currency (Bs, etc.).
   */
  function formatPriceFacetLabel(cents, formatStr, block) {
    var shopIso = normalizeIsoCurrency(block && block.getAttribute('data-shop-currency'));
    var cartIso = normalizeIsoCurrency(block && block.getAttribute('data-presentment-currency'));
    var activeIso = getShopifyActiveCurrencyIso();
    var targetIso = cartIso || activeIso;
    var useIntl = false;
    if (targetIso) {
      if (shopIso) useIntl = targetIso !== shopIso;
      else useIntl = true;
    }
    if (useIntl) {
      var intl = formatMoneyIntlMinorUnits(cents, targetIso);
      if (intl) return intl;
    }
    return formatDisplayMoney(cents, formatStr);
  }

  function decodeHtmlAttr(s) {
    if (s == null || s === '') return s;
    var t = document.createElement('textarea');
    t.innerHTML = s;
    return t.value;
  }

  /** Shopify money format strings from section HTML (Liquid-escaped attrs). Prefer with-currency. */
  function getFacetMoneyFormats(block) {
    var withCur = decodeHtmlAttr(block && block.getAttribute('data-money-with-currency-format'));
    var plain = decodeHtmlAttr(block && block.getAttribute('data-money-format'));
    return { withCurrency: withCur || '', plain: plain || '' };
  }

  function getFacetMoneyFormatForJs(block) {
    var fm = getFacetMoneyFormats(block);
    if (fm.withCurrency) return fm.withCurrency;
    if (fm.plain) return fm.plain;
    return '';
  }

  /** Current URL wins over stale hidden inputs after partial rendering. */
  function readPriceFacetFromUrl(minKey, maxKey) {
    if (!minKey || !maxKey) return null;
    try {
      var q = new URLSearchParams(window.location.search);
      var a = q.get(minKey);
      var b = q.get(maxKey);
      if (a == null || b == null) return null;
      var v1 = parseInt(String(a).trim(), 10);
      var v2 = parseInt(String(b).trim(), 10);
      if (isNaN(v1) || isNaN(v2)) return null;
      return { v1: v1, v2: v2 };
    } catch (e) {
      return null;
    }
  }

  function collectOpenFacetKeys(root) {
    var keys = [];
    if (!root) return keys;
    root.querySelectorAll('.ncs-facet__details[open][data-ncs-facet]').forEach(function (d) {
      var k = d.getAttribute('data-ncs-facet');
      if (k) keys.push(k);
    });
    return keys;
  }

  function restoreOpenFacets(root, keys) {
    if (!root || !keys.length) return;
    keys.forEach(function (k) {
      if (!k || /["'<>]/.test(k)) return;
      var d = root.querySelector('.ncs-facet__details[data-ncs-facet="' + k + '"]');
      if (d) d.setAttribute('open', '');
    });
  }

  /** Remove only the section script (double-run is confusing); keep CSS link on the replaced tree. */
  function stripSectionScripts(node) {
    if (!node) return;
    node.querySelectorAll('script[src*="nucery-collection-showcase.js"]').forEach(function (n) {
      n.parentNode && n.parentNode.removeChild(n);
    });
  }

  /** After AJAX replace, the old <link> left with the removed node; re-attach if Shopify omitted it. */
  function ensureNuceryShowcaseCss(showcase) {
    if (document.querySelector('link[href*="nucery-collection-showcase.css"]')) return;
    var href = showcase && showcase.getAttribute('data-ncs-css-href');
    if (!href) return;
    var link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = href;
    document.head.appendChild(link);
  }

  /**
   * Section instance id for ?section_id= (same as Impulse AjaxRenderer + Liquid section.id).
   */
  function getSectionsApiId(showcase) {
    var fromAttr = showcase && showcase.getAttribute('data-ncs-sections-api-id');
    if (fromAttr) return fromAttr.trim();
    var wrap = showcase && showcase.closest('.shopify-section');
    var idAttr = wrap && wrap.id;
    if (idAttr && idAttr.indexOf('shopify-section-') === 0) {
      return idAttr.replace(/^shopify-section-/, '');
    }
    return 'nucery-collection-showcase';
  }

  function ajaxEnabled(showcase) {
    return showcase && showcase.getAttribute('data-ncs-ajax') === 'true';
  }

  function findPriceHiddenInputs(block, minName, maxName) {
    var hMin;
    var hMax;
    if (!block) return { hMin: null, hMax: null };
    block.querySelectorAll('input[type="hidden"]').forEach(function (inp) {
      if (minName && inp.name === minName) hMin = inp;
      if (maxName && inp.name === maxName) hMax = inp;
    });
    return { hMin: hMin, hMax: hMax };
  }

  function readRangeStep(rangeInput) {
    var raw = rangeInput && rangeInput.getAttribute('step');
    if (raw == null || String(raw).trim() === '') return 1;
    var st = parseInt(String(raw), 10);
    if (!isNaN(st) && st >= 1) return st;
    return 1;
  }

  function snapCentsToStep(v, lo, hi, step) {
    step = Math.max(1, step || 1);
    if (hi <= lo) return v;
    var n = lo + Math.round((v - lo) / step) * step;
    return Math.max(lo, Math.min(hi, n));
  }

  /** True bounds come from native range min/max (matches Shopify-rendered facets). data-* is fallback. */
  function readNumericRangeBounds(block, rMin, rMax) {
    var lo = parseInt(String(rMin.min), 10);
    var hi = parseInt(String(rMax.max), 10);
    if (isNaN(lo)) lo = parseInt(block.getAttribute('data-min') || '0', 10);
    if (isNaN(hi)) hi = parseInt(block.getAttribute('data-max') || '0', 10);
    return { lo: lo, hi: hi };
  }

  function parseCentsFlexible(raw, fallback) {
    var x = parseInt(String(raw).trim(), 10);
    return isNaN(x) ? fallback : x;
  }

  /** Shopify storefront misbehaves when min=max; enforce spread by at least one step when possible. */
  function computeSortedPriceValues(minCents, maxCents, rawMin, rawMax, step) {
    step = Math.max(1, step || 1);
    if (maxCents <= minCents) return { v1: minCents, v2: maxCents };
    var v1 = parseInt(String(rawMin), 10);
    var v2 = parseInt(String(rawMax), 10);
    if (isNaN(v1)) v1 = minCents;
    if (isNaN(v2)) v2 = maxCents;
    if (v1 > v2) {
      var t = v1;
      v1 = v2;
      v2 = t;
    }
    v1 = Math.max(minCents, Math.min(maxCents, v1));
    v2 = Math.max(minCents, Math.min(maxCents, v2));
    v1 = snapCentsToStep(v1, minCents, maxCents, step);
    v2 = snapCentsToStep(v2, minCents, maxCents, step);
    if (v2 <= v1) {
      if (v1 + step <= maxCents) v2 = v1 + step;
      else if (v2 - step >= minCents) v1 = v2 - step;
      else {
        v1 = minCents;
        v2 = maxCents;
      }
    }
    return { v1: v1, v2: v2 };
  }

  /**
   * Hydrate/sync UI + hidden facet inputs from sliders.
   * snap=false after AJAX / first paint — trust Shopify values; do NOT step-snapping (fixes URL≠UI mismatches).
   * snap=true on user input / before submit — apply step grid + Shopify-safe min/max spread.
   */
  function commitPriceFacetUI(block, snap) {
    if (!block) return;
    var minName = block.getAttribute('data-min-name');
    var maxName = block.getAttribute('data-max-name');
    var rMin = block.querySelector('.ncs-price__range--min');
    var rMax = block.querySelector('.ncs-price__range--max');
    var fill = block.querySelector('.ncs-price__track-fill');
    var elMinLabel = block.querySelector('.ncs-price__min');
    var elMaxLabel = block.querySelector('.ncs-price__max');
    var moneyFmt = getFacetMoneyFormatForJs(block);

    var hh = findPriceHiddenInputs(block, minName, maxName);
    if (!rMin || !rMax || !hh.hMin || !hh.hMax || !fill) return;

    var bounds = readNumericRangeBounds(block, rMin, rMax);
    var lo = bounds.lo;
    var hi = bounds.hi;

    var v1;
    var v2;
    var fromUrl = !snap ? readPriceFacetFromUrl(minName, maxName) : null;
    if (!snap) {
      if (fromUrl) {
        v1 = fromUrl.v1;
        v2 = fromUrl.v2;
      } else {
        v1 = parseCentsFlexible(hh.hMin.value, parseCentsFlexible(rMin.value, lo));
        v2 = parseCentsFlexible(hh.hMax.value, parseCentsFlexible(rMax.value, hi));
      }
    } else {
      v1 = parseCentsFlexible(rMin.value, parseCentsFlexible(hh.hMin.value, lo));
      v2 = parseCentsFlexible(rMax.value, parseCentsFlexible(hh.hMax.value, hi));
    }

    if (!snap) {
      v1 = Math.max(lo, Math.min(hi, v1));
      v2 = Math.max(lo, Math.min(hi, v2));
      if (v1 > v2) {
        var swap = v1;
        v1 = v2;
        v2 = swap;
      }
      var gapStep = Math.max(1, readRangeStep(rMin));
      if (v2 <= v1 && hi > lo) {
        if (v1 + gapStep <= hi) v2 = v1 + gapStep;
        else if (v2 - gapStep >= lo) v1 = v2 - gapStep;
        else {
          v1 = lo;
          v2 = hi;
        }
      }
    } else {
      var step = readRangeStep(rMin);
      var pair = computeSortedPriceValues(lo, hi, v1, v2, step);
      v1 = pair.v1;
      v2 = pair.v2;
    }

    rMin.value = String(v1);
    rMax.value = String(v2);
    hh.hMin.value = String(v1);
    hh.hMax.value = String(v2);
    rMin.setAttribute('aria-valuenow', String(v1));
    rMax.setAttribute('aria-valuenow', String(v2));

    elMinLabel && (elMinLabel.textContent = formatPriceFacetLabel(v1, moneyFmt, block));
    elMaxLabel && (elMaxLabel.textContent = formatPriceFacetLabel(v2, moneyFmt, block));

    var span = hi - lo || 1;
    fill.style.left = Math.round(((v1 - lo) / span) * 100) + '%';
    fill.style.width = Math.round(((v2 - v1) / span) * 100) + '%';
  }

  function syncAllNcsPriceBlocksInShowcase(showcase) {
    if (!showcase) return;
    showcase.querySelectorAll('[data-ncs-price]').forEach(function (b) {
      commitPriceFacetUI(b, true);
    });
  }

  /**
   * Impulse uses one filter/sort flow; we duplicate sidebar + drawer forms. Each has its own
   * `sort_by` radio group, so both could submit → `sort_by=a&sort_by=b` and Shopify/storefront
   * behavior breaks (price + sort fight). Copy the triggering form's selection to every sibling form.
   */
  function syncSortRadiosAcrossForms(showcase, sourceForm) {
    if (!showcase || !sourceForm) return;
    var picked = sourceForm.querySelector('input[name="sort_by"]:checked');
    if (!picked) return;
    var v = picked.value;
    showcase.querySelectorAll('form[data-ncs-facets] input[name="sort_by"]').forEach(function (radio) {
      radio.checked = String(radio.value) === String(v);
    });
  }

  /** Duplicate forms otherwise keep different availability choices → URL gets both `=1` and `=0`. */
  function syncAvailabilityAcrossForms(showcase, sourceForm) {
    if (!showcase || !sourceForm) return;
    var sel = 'form[data-ncs-facets] input[name="' + NCS_AVAILABILITY_PARAM + '"]';
    var picked = sourceForm.querySelector(sel + ':checked');
    showcase.querySelectorAll(sel).forEach(function (inp) {
      if (!picked) {
        inp.checked = false;
        return;
      }
      inp.checked = String(inp.value) === String(picked.value);
    });
  }

  /**
   * Sidebar + drawer each render `form[data-ncs-facets]`. Merge every form's FormData with deduped
   * name=value pairs so tag/availability from one form aren't dropped when the request runs from the other.
   * `sort_by` must appear at most once — enforced after syncSortRadiosAcrossForms + explicit singular append.
   * `filter.v.availability` must appear at most once (exclusive in/out stock).
   */
  function mergeFacetFormDataFromShowcase(showcase) {
    var out = new URLSearchParams();
    var seen = new Set();
    if (!showcase) return out;

    showcase.querySelectorAll('form[data-ncs-facets]').forEach(function (form) {
      new URLSearchParams(new FormData(form)).forEach(function (value, key) {
        if (value === '') return;
        if (key === 'sort_by' || key === NCS_AVAILABILITY_PARAM) {
          return;
        }
        var sig = key + '\0' + value;
        if (seen.has(sig)) return;
        seen.add(sig);
        out.append(key, value);
      });
    });

    var canonicalSort = showcase.querySelector('form[data-ncs-facets] input[name="sort_by"]:checked');
    if (canonicalSort && canonicalSort.value !== '') {
      out.append('sort_by', canonicalSort.value);
    }

    var canonicalAvail = showcase.querySelector(
      'form[data-ncs-facets] input[name="' + NCS_AVAILABILITY_PARAM + '"]:checked'
    );
    if (canonicalAvail && String(canonicalAvail.value).trim() !== '') {
      out.append(NCS_AVAILABILITY_PARAM, canonicalAvail.value);
    }

    return out;
  }

  /** Keep duplicate price blocks (sidebar vs drawer) in sync after the user drags one slider. */
  function mirrorPriceFacetToSiblings(sourceBlock) {
    var showcase = closest(sourceBlock, '.nucery-collection-showcase');
    if (!showcase || !sourceBlock) return;
    var minK = sourceBlock.getAttribute('data-min-name');
    var maxK = sourceBlock.getAttribute('data-max-name');
    if (!minK || !maxK) return;
    var rMin = sourceBlock.querySelector('.ncs-price__range--min');
    var rMax = sourceBlock.querySelector('.ncs-price__range--max');
    var srcH = findPriceHiddenInputs(sourceBlock, minK, maxK);
    if (!rMin || !rMax || !srcH.hMin || !srcH.hMax) return;
    var v1 = String(rMin.value);
    var v2 = String(rMax.value);

    showcase.querySelectorAll('[data-ncs-price]').forEach(function (other) {
      if (other === sourceBlock) return;
      if (other.getAttribute('data-min-name') !== minK || other.getAttribute('data-max-name') !== maxK) return;
      var oMn = other.querySelector('.ncs-price__range--min');
      var oMx = other.querySelector('.ncs-price__range--max');
      var oH = findPriceHiddenInputs(other, minK, maxK);
      if (!oMn || !oMx || !oH.hMin || !oH.hMax) return;
      oMn.value = v1;
      oMx.value = v2;
      oH.hMin.value = v1;
      oH.hMax.value = v2;
      oMn.setAttribute('aria-valuenow', v1);
      oMx.setAttribute('aria-valuenow', v2);
      commitPriceFacetUI(other, true);
    });
  }

  /** When slider spans the whole catalog price range, omit params (neutral = unfiltered catalog). */
  function stripNeutralPriceFacetParamsFromMerged(merged, showcase) {
    if (!merged || !showcase) return;
    showcase.querySelectorAll('[data-ncs-price]').forEach(function (block) {
      var rMn = block.querySelector('.ncs-price__range--min');
      var rMx = block.querySelector('.ncs-price__range--max');
      var lo = parseInt(String(rMn && rMn.min), 10);
      var hi = parseInt(String(rMx && rMx.max), 10);
      if (isNaN(lo)) lo = parseInt(block.getAttribute('data-min') || '0', 10);
      if (isNaN(hi)) hi = parseInt(block.getAttribute('data-max') || '0', 10);
      var minK = block.getAttribute('data-min-name');
      var maxK = block.getAttribute('data-max-name');
      if (!(hi >= lo) || !minK || !maxK) return;
      var a = merged.get(minK);
      var b = merged.get(maxK);
      if (a == null || b == null || String(a).trim() === '' || String(b).trim() === '') return;
      var vmin = parseInt(String(a), 10);
      var vmax = parseInt(String(b), 10);
      if (isNaN(vmin) || isNaN(vmax)) return;
      if (vmin <= lo && vmax >= hi) {
        merged.delete(minK);
        merged.delete(maxK);
      }
    });
  }

  /** Path segment for storefront filters (`filter.*`, `sort_by`) — must match the collection that owns `target_collection` in Liquid (`form.action`), not necessarily `location.pathname`. */
  function resolveCollectionPathname(form) {
    var showcase = closest(form, '.nucery-collection-showcase');
    var trial = function (href) {
      if (href == null || String(href).trim() === '') return null;
      try {
        var u = new URL(String(href).trim(), window.location.origin);
        if (u.origin !== window.location.origin) return null;
        var p = u.pathname;
        return p && p.length ? p : '/';
      } catch (e) {
        return null;
      }
    };
    var p = trial(form && form.getAttribute('action')) || trial(showcase && showcase.getAttribute('data-ncs-collection-url'));
    return p || window.location.pathname;
  }

  function preservedParamKey(key) {
    var preserved = ['q', 'options[prefix]', 'type'];
    if (preserved.indexOf(key) !== -1) return true;
    if (key.indexOf('utm_') === 0) return true;
    return false;
  }

  /**
   * Same merge strategy as Impulse `theme.AjaxRenderer.getUpdatedParams` (theme.js ~1510):
   * merge current URL with new facet FormData — drop stale keys whose values disappeared from the
   * form submission, append new pairs, preserve search / utm / etc. `sort_by` is not preserved here
   * because `mergeFacetFormDataFromShowcase` always emits the canonical sort from the radios.
   */
  function getUpdatedParams(currentParams, newParams) {
    var clone = new URLSearchParams(currentParams.toString());
    var snapshot = [];
    clone.forEach(function (value, key) {
      snapshot.push([key, value]);
    });

    snapshot.forEach(function (pair) {
      var key = pair[0];
      var value = pair[1];
      if (preservedParamKey(key)) return;
      if (newParams.getAll(key).indexOf(value) === -1) {
        clone.delete(key);
      }
    });

    newParams.forEach(function (value, key) {
      if (value !== '') {
        if (clone.getAll(key).indexOf(value) === -1) {
          clone.append(key, value);
        }
      }
    });

    return clone;
  }

  /**
   * Storefront multi-select facets repeat the same key with different values, e.g.
   * ?filter.p.m.custom.type=Rings&filter.p.m.custom.type=Necklaces (OR within that facet).
   * Toggle one pair: remove a matching entry if present, otherwise append (stacked “type” pills).
   */
  function toggleQueryParamValue(searchParams, key, value) {
    var sp = new URLSearchParams(searchParams.toString());
    var vals = sp.getAll(key);
    if (vals.indexOf(value) !== -1) {
      var next = new URLSearchParams();
      var removedOne = false;
      sp.forEach(function (v, k) {
        if (!removedOne && k === key && v === value) {
          removedOne = true;
          return;
        }
        next.append(k, v);
      });
      return next;
    }
    sp.append(key, value);
    return sp;
  }

  /**
   * Pill block href carries one facet fragment (e.g. filter.p.m.custom.type=Rings). Merge into the
   * current collection URL so a second pill adds Necklaces instead of replacing Rings (stores like
   * Beautiful Earth Boutique).
   */
  function buildUrlWithPillToggle(pillAnchor) {
    var hrefAttr = pillAnchor.getAttribute('href');
    if (!hrefAttr) return hrefAttr;
    var pillUrl = new URL(hrefAttr, window.location.origin);
    var pillQs = new URLSearchParams(pillUrl.search);
    if (pillQs.toString() === '') return hrefAttr;

    var current = new URL(window.location.href);
    if (current.pathname !== pillUrl.pathname) return hrefAttr;

    var merged = new URLSearchParams(current.search);
    merged.delete('sections');
    merged.delete('section_id');

    pillQs.forEach(function (value, key) {
      merged = toggleQueryParamValue(merged, key, value);
    });
    merged.delete('page');

    var out = new URL(pillUrl.pathname, window.location.origin);
    out.search = merged.toString();
    return out.toString();
  }

  /**
   * Impulse-style: pathname from collection form + `getUpdatedParams(location, facetFormData)`.
   */
  function buildCollectionFilterUrl(form) {
    var showcase = closest(form, '.nucery-collection-showcase');
    if (showcase && form) {
      syncSortRadiosAcrossForms(showcase, form);
      syncAvailabilityAcrossForms(showcase, form);
    }
    syncAllNcsPriceBlocksInShowcase(showcase);

    var base = new URL(resolveCollectionPathname(form), window.location.origin);
    var current = new URLSearchParams(window.location.search);
    current.delete('sections');
    current.delete('section_id');

    var facetParams = showcase ? mergeFacetFormDataFromShowcase(showcase) : new URLSearchParams(new FormData(form));
    var merged = getUpdatedParams(current, facetParams);

    stripNeutralPriceFacetParamsFromMerged(merged, showcase || form);

    base.search = merged.toString();
    return base;
  }

  function urlForHistoryBar(u) {
    var c = new URL(u.toString());
    c.searchParams.delete('sections');
    c.searchParams.delete('section_id');
    return c.pathname + c.search;
  }

  function fetchAndReplaceSection(shopSection, fetchUrl, opts) {
    opts = opts || {};
    var showcase = shopSection.querySelector('.nucery-collection-showcase');
    if (!showcase || !ajaxEnabled(showcase)) {
      window.location.href = typeof fetchUrl === 'string' ? fetchUrl : fetchUrl.href;
      return;
    }

    var sectionKey = getSectionsApiId(showcase);
    var u = typeof fetchUrl === 'string' ? new URL(fetchUrl, window.location.origin) : fetchUrl;
    u.searchParams.delete('sections');
    u.searchParams.set('section_id', sectionKey);

    var openKeys = collectOpenFacetKeys(shopSection);
    var scrollY = window.scrollY;
    var loadingEl = shopSection;
    loadingEl.classList.add('ncs-is-loading');

    fetch(u.toString(), {
      method: 'GET',
      credentials: 'same-origin',
    })
      .then(function (r) {
        if (!r.ok) throw new Error('Network');
        return r.text();
      })
      .then(function (html) {
        html = typeof html === 'string' ? html.trim() : '';
        if (!html) throw new Error('Empty section response');

        var doc = new DOMParser().parseFromString(html, 'text/html');
        var incoming =
          doc.querySelector('.shopify-section') ||
          doc.querySelector('section.nucery-collection-showcase') ||
          doc.body.firstElementChild;
        if (!incoming) throw new Error('No section markup');

        if (!(incoming.classList && incoming.classList.contains('shopify-section'))) {
          var wrap = shopSection.cloneNode(false);
          wrap.innerHTML = '';
          wrap.appendChild(incoming);
          incoming = wrap;
        }

        stripSectionScripts(incoming);

        shopSection.parentNode.replaceChild(incoming, shopSection);

        var newShowcase = incoming.querySelector('.nucery-collection-showcase');
        ensureNuceryShowcaseCss(newShowcase);
        restoreOpenFacets(incoming, openKeys);

        history.pushState({}, '', urlForHistoryBar(u));

        if (newShowcase) {
          initPrice(newShowcase);
        }

        if (opts.afterReplace) opts.afterReplace(incoming);

        window.scrollTo(0, scrollY);

        document.dispatchEvent(
          new CustomEvent('ncs:section-replaced', {
            detail: { section: incoming, showcase: newShowcase },
          })
        );
      })
      .catch(function () {
        window.location.href = urlForHistoryBar(u);
      })
      .finally(function () {
        if (loadingEl && loadingEl.classList) {
          loadingEl.classList.remove('ncs-is-loading');
        }
        document.querySelectorAll('.shopify-section.ncs-is-loading').forEach(function (el) {
          el.classList.remove('ncs-is-loading');
        });
      });
  }

  function submitFacetsAjax(form) {
    var showcase = form.closest('.nucery-collection-showcase');
    var shopSection = showcase && showcase.closest('.shopify-section');
    if (!shopSection) return;

    var drawer = form.closest('.ncs-drawer');
    if (drawer) {
      var trig = shopSection.querySelector('[data-ncs-open-drawer]');
      closeDrawer(drawer, trig);
    }

    var u = buildCollectionFilterUrl(form);
    fetchAndReplaceSection(shopSection, u);
  }

  function initPrice(root) {
    root.querySelectorAll('[data-ncs-price]').forEach(function (block) {
      var rMin = block.querySelector('.ncs-price__range--min');
      var rMax = block.querySelector('.ncs-price__range--max');
      var minName = block.getAttribute('data-min-name');
      var maxName = block.getAttribute('data-max-name');
      var hh = findPriceHiddenInputs(block, minName, maxName);
      var fill = block.querySelector('.ncs-price__track-fill');
      if (!rMin || !rMax || !hh.hMin || !hh.hMax || !fill) return;

      function bringFront(el) {
        rMin.classList.remove('ncs-price--front');
        rMax.classList.remove('ncs-price--front');
        if (el) el.classList.add('ncs-price--front');
      }

      ['pointerdown', 'mousedown', 'touchstart'].forEach(function (ev) {
        rMin.addEventListener(ev, function () {
          bringFront(rMin);
        });
        rMax.addEventListener(ev, function () {
          bringFront(rMax);
        });
      });

      function onRangeUserAdjust() {
        commitPriceFacetUI(block, true);
        mirrorPriceFacetToSiblings(block);
      }

      rMin.addEventListener('input', onRangeUserAdjust);
      rMax.addEventListener('input', onRangeUserAdjust);
      rMin.addEventListener('change', onRangeUserAdjust);
      rMax.addEventListener('change', onRangeUserAdjust);

      commitPriceFacetUI(block, false);
    });
  }

  function initNcsBestsellerCarousels(root) {
    if (typeof window.initBestsellerCarousels !== 'function') return;
    var scope = root || document;
    scope.querySelectorAll('.nucery-collection-showcase').forEach(function (showcase) {
      if (showcase.querySelector('[data-bst-carousel]')) {
        window.initBestsellerCarousels(showcase);
      }
    });
  }

  function boot() {
    document.querySelectorAll('.nucery-collection-showcase').forEach(initPrice);
    initNcsBestsellerCarousels(document);
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('form[data-ncs-facets]')) return;
    var showcase = form.closest('.nucery-collection-showcase');
    if (!showcase || !ajaxEnabled(showcase)) return;
    e.preventDefault();
    submitFacetsAjax(form);
  });

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.matches) return;
    var showcase = t.closest('.nucery-collection-showcase');
    if (!showcase || !ajaxEnabled(showcase)) return;

    if (t.matches('input[type="checkbox"], input[type="radio"], select')) {
      var form = closest(t, 'form[data-ncs-facets]');
      if (form) {
        if (t.matches('input[name="' + NCS_AVAILABILITY_PARAM + '"]')) {
          syncAvailabilityAcrossForms(showcase, form);
        }
        submitFacetsAjax(form);
      }
      return;
    }

    if (t.matches('.ncs-price__range')) {
      var formP = closest(t, 'form[data-ncs-facets]');
      if (formP) submitFacetsAjax(formP);
    }
  });

  document.addEventListener('click', function (e) {
    var openBtn = e.target.closest('[data-ncs-open-drawer]');
    if (openBtn) {
      var drawerId = openBtn.getAttribute('aria-controls');
      var drawer = drawerId && document.getElementById(drawerId);
      if (drawer) {
        openDrawer(drawer, openBtn);
      }
      return;
    }

    if (e.target.closest('[data-ncs-close-drawer]')) {
      var closeEl = e.target.closest('[data-ncs-close-drawer]');
      var drawer = closeEl && closeEl.closest('.ncs-drawer');
      if (drawer) {
        var root = drawer.closest('.shopify-section');
        var trigger = root && root.querySelector('[data-ncs-open-drawer]');
        closeDrawer(drawer, trigger);
      }
      return;
    }

    if (e.target.closest('[data-ncs-apply]')) {
      var applyBtn = e.target.closest('[data-ncs-apply]');
      var drawer = applyBtn && applyBtn.closest('.ncs-drawer');
      var form = drawer && drawer.querySelector('form[data-ncs-facets]');
      if (form && ajaxEnabled(form.closest('.nucery-collection-showcase'))) {
        e.preventDefault();
        submitFacetsAjax(form);
      }
      return;
    }

    var clearA = e.target.closest('[data-ncs-clear-filters]');
    if (clearA) {
      var sec = clearA.closest('.shopify-section');
      var sh = sec && sec.querySelector('.nucery-collection-showcase');
      if (sec && sh && ajaxEnabled(sh)) {
        e.preventDefault();
        var href = clearA.getAttribute('href');
        var openDrawerEl = document.querySelector('.ncs-drawer.is-open');
        if (openDrawerEl) {
          var r = openDrawerEl.closest('.shopify-section');
          var trig = r && r.querySelector('[data-ncs-open-drawer]');
          closeDrawer(openDrawerEl, trig);
        }
        fetchAndReplaceSection(sec, href);
      }
      return;
    }

    var pillFilter = e.target.closest('a.ncs-pill--filter[href]');
    if (pillFilter && pillFilter.getAttribute('href') !== '#') {
      var secP = pillFilter.closest('.shopify-section');
      var shP = secP && secP.querySelector('.nucery-collection-showcase');
      if (secP && shP && ajaxEnabled(shP)) {
        e.preventDefault();
        fetchAndReplaceSection(secP, buildUrlWithPillToggle(pillFilter));
        return;
      }
    }

    var pg = e.target.closest('.ncs-pagination a[href]');
    if (pg) {
      var sec2 = pg.closest('.shopify-section');
      var sh2 = sec2 && sec2.querySelector('.nucery-collection-showcase');
      if (sec2 && sh2 && ajaxEnabled(sh2)) {
        e.preventDefault();
        fetchAndReplaceSection(sec2, pg.href);
      }
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var openDrawer = document.querySelector('.ncs-drawer.is-open');
    if (!openDrawer || !document.body.contains(openDrawer)) return;
    var root = openDrawer.closest('.shopify-section');
    var trigger = root && root.querySelector('[data-ncs-open-drawer]');
    closeDrawer(openDrawer, trigger);
  });

  if (window.history && window.history.replaceState) {
    window.addEventListener('popstate', function () {
      window.location.reload();
    });
  }

  document.addEventListener('ncs:section-replaced', function (e) {
    var showcase = e.detail && e.detail.showcase;
    if (showcase) {
      initNcsBestsellerCarousels(showcase);
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
